import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import MasonryHero from './components/MasonryHero';
import MasonryServices from './components/MasonryServices';
import MasonryTypesElPaso from './components/MasonryTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import MasonryFAQ from './components/MasonryFAQ';

export default function MasonryPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <MasonryHero />
        <MasonryServices />
        <MasonryTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <MasonryFAQ />
      </main>
      <Footer />
    </div>
  );
}
